import { chakra } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
const Span = chakra("span");
export function SkeletonText() {
    const root = useRef(null);
    const [lines, setLines] = useState(0);
    const [lineHeight, setLineHeight] = useState(0);
    useEffect(() => {
        const container = root.current?.parentElement;
        if (!container) {
            return;
        }
        const containerHeight = container.offsetHeight;
        const lineHeight = Number.parseFloat(window.getComputedStyle(container).lineHeight);
        const lines = Math.round(containerHeight / lineHeight);
        setLines(lines);
        setLineHeight(lineHeight);
    }, []);
    return (React.createElement(Span, { ref: root, display: "flex", flexDirection: "column", position: "absolute", inset: 0 }, Array.from({ length: lines }).map((_line, index) => (React.createElement(Span
    // eslint-disable-next-line react/no-array-index-key
    , { 
        // eslint-disable-next-line react/no-array-index-key
        key: index, position: "absolute", top: `${index * lineHeight}px`, width: "100%", height: `${lineHeight}px`, display: "flex", alignItems: "center" },
        React.createElement(Span, { display: "block", width: "100%", height: "50%", background: "var(--skeleton-color)" }))))));
}
